(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/preview/preview.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/preview/preview.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
const GiftInfo = svs.tickets_giftshop.preview.components.GiftInfo;
const Products = svs.tickets_giftshop.products.Products;
const _svs$components$tur$b = svs.components.tur.backgrounds,
  TrissBackground = _svs$components$tur$b.TrissBackground,
  SkrapspelBackground = _svs$components$tur$b.SkrapspelBackground;
const GIFT_ROUTE = svs.tickets_giftshop.constants.routes.GIFT_ROUTE;
const _svs$tickets_giftshop = svs.tickets_giftshop.constants.names,
  EMAIL = _svs$tickets_giftshop.EMAIL,
  PHONE = _svs$tickets_giftshop.PHONE;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.functions,
  createJupiterVoucherPaymentObject = _svs$tickets_giftshop2.createJupiterVoucherPaymentObject,
  productsPerAmountFromCart = _svs$tickets_giftshop2.productsPerAmountFromCart,
  deliveryDateHasChanged = _svs$tickets_giftshop2.deliveryDateHasChanged;
const _svs$tickets_giftshop3 = svs.tickets_giftshop.constants.branding,
  TRISS = _svs$tickets_giftshop3.TRISS,
  SKRAPSPEL = _svs$tickets_giftshop3.SKRAPSPEL,
  DEFAULT = _svs$tickets_giftshop3.DEFAULT;
const _svs$tickets_giftshop4 = svs.tickets_giftshop.constants.cart,
  SET = _svs$tickets_giftshop4.SET,
  APPEND = _svs$tickets_giftshop4.APPEND;
const cartClearAction = svs.tickets_giftshop.gift.giftform.cart.actions.cartClearAction;
const formClearAction = svs.tickets_giftshop.gift.giftform.actions.formClearAction;
const getCart = svs.tickets_giftshop.gift.giftform.cart.getters.getCart;
const payTickets = svs.tickets_giftshop.services.payTickets;
const Preview = _ref => {
  let history = _ref.history,
    formData = _ref.formData,
    _ref$cart = _ref.cart,
    cart = _ref$cart === void 0 ? [] : _ref$cart,
    cartSum = _ref.cartSum,
    cartCount = _ref.cartCount,
    onResetShop = _ref.onResetShop,
    branding = _ref.branding;
  const balance = svs.tickets_giftshop.hooks.useBalance();
  window.scrollTo(0, 0);
  const isPayDisabled = () => {
    let isValid = true;
    if (formData.receiverType === EMAIL && !formData.email) {
      isValid = false;
    }
    isValid = isValid && !name && !cartCount;
    return isValid;
  };
  React.useEffect(() => {
    if (!cart.length) {
      history.push('/');
    }
  }, [cart]);
  React.useEffect(() => {
    if (svs.utils.paramHandler.get({
      key: 'ispay'
    }).value === 'true' && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'ispay'
      });
      handlePay();
    }
  }, []);
  const handleChangeClick = e => {
    e && e.preventDefault();
    history && history.push(GIFT_ROUTE);
  };
  const handlePay = e => {
    e && e.preventDefault();
    svs.utils.paramHandler.set({
      key: 'ispay',
      value: 'true'
    });
    payTickets({
      trackingData: {
        dateSelectorUsed: formData.dateSelectorUsed,
        dateSelector: formData.dateSelector,
        cart
      },
      request: createJupiterVoucherPaymentObject(_objectSpread(_objectSpread({
        cart
      }, formData), {}, {
        price: cartSum
      })),
      onCancel: () => {},
      onDone: () => {
        onResetShop && onResetShop();
      }
    });
  };
  const isTriss = branding === TRISS;
  const isSkrapspel = branding === SKRAPSPEL;
  const isDefault = branding === DEFAULT;
  const payfooterButtonOps = [{
    pay: true,
    onClick: handlePay,
    disabled: isPayDisabled()
  }, {
    secondary: true,
    text: 'Ändra',
    onClick: handleChangeClick
  }];
  let datestring = 'Direkt';
  const iso = dateFns.parseISO("".concat(formData.date, "T").concat(formData.time));
  if (deliveryDateHasChanged({
    date: formData.date,
    time: formData.time,
    currentDate: Date.now()
  })) {
    datestring = "".concat(svs.utils.date.FormatTime('dd MMMM yyyy', iso), " kl ").concat(svs.utils.date.SimpleTime(iso));
  }
  return React.createElement(React.Fragment, null, isTriss && React.createElement(TrissBackground, null), (isSkrapspel || isDefault) && React.createElement(SkrapspelBackground, null), React.createElement("div", {
    className: "tg-preview-bubble-info data-hj-suppress"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: "".concat(formData.personalGreeting, " ").concat(formData.name, "!")
  }, formData.greeting)), React.createElement(Products, {
    isImageOnly: true,
    products: productsPerAmountFromCart(cart)
  }), React.createElement(GiftInfo, {
    dateString: datestring,
    email: formData.email,
    phone: formData.phone,
    receiverType: formData.receiverType,
    totalProducts: cartCount,
    totalProductSum: cartSum
  }), React.createElement("div", {
    className: "tg-preview-payfooter"
  }, React.createElement(Payfooter, {
    balance: balance,
    buttons: payfooterButtonOps,
    isLegalInfo: true,
    reminderTrackingLabel: "preview ".concat(isTriss ? 'Triss' : 'Skrapspel', " Voucher"),
    sum: cartSum
  })));
};
const mapDispatch = dispatch => ({
  onResetShop: () => {
    dispatch(cartClearAction());
    dispatch(formClearAction());
  }
});
const mapStateToProps = state => {
  const _getCart = getCart(state),
    cart = _getCart.cart,
    count = _getCart.count,
    sum = _getCart.sum;
  return {
    formData: state.giftform,
    cart,
    cartCount: count || 0,
    cartSum: sum || 0,
    branding: state.settings.branding
  };
};
svs.tickets_giftshop.preview.Preview = ReactRedux.connect(mapStateToProps, mapDispatch)(Preview);

 })(window);